// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-btn[data-v-553f4953] {\n  width: 167px;\n  height: 42px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.confirm-btn.disabled[data-v-553f4953] {\n    background-color: gray;\n    border-color: gray;\n    cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
